<template>
  <div class="menu-under-bar">
    <ul>
      <li
        v-for="(item, index) in data"
        :key="index"
        @click.stop="goToRoute(item.name)"
        :id="item.name"
      >
        {{ item.title }}
      </li>
    </ul>
    <div id="pageUnderBar" class="under-bar"></div>
  </div>
</template>

<script>
import { of } from 'rxjs'
import { map, delay } from 'rxjs/operators'

export default {
  name: 'menu-under-bar',
  props: {
    data: {
      default: () => ({
        0: {
          title: 'Default1',
          name: 'main',
          sort: 0
        },
        1: {
          title: 'Default2',
          name: 'main1',
          sort: 0
        },
        2: {
          title: 'Default3',
          name: 'main2',
          sort: 0
        },
        3: {
          title: 'Default4',
          name: 'main3',
          sort: 0
        },
        4: {
          title: 'Default5',
          name: 'main4',
          sort: 0
        }
      }),
      type: [Array, Object]
    }
  },
  data() {
    return {
      currentMenu: '',
      randomId: new Date().getTime().toString(),
      currentPath: this.$route.path.split('/')
    }
  },
  mounted() {
    this.setPositionMenuUnderBar(this.currentPath)
  },
  watch: {
    $route: function(to) {
      this.setPositionMenuUnderBar(to.path.split('/'))
    }
  },
  methods: {
    setPositionMenuUnderBar(path) {
      // console.log('path:', path)
      this.getElement(path[2])
        .then(r => {
          if (r) {
            if (path.length > 3) {
              this.$router.push({ path: path[3] })
            } else {
              this.$router.push({ path: path[2] })
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    goToRoute(path) {
      this.getElement(path)
        .then(r => {
          if (r) {
            this.$router.push({ path: '/' + this.currentPath[1] + '/' + path })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    async getElement(id) {
      console.log('id:', id)
      return this.$nextTick().then(() => {
        const target = this.$el.querySelector('#' + id)
        const underBar = this.$el.querySelector('#pageUnderBar')
        underBar.className = 'animated under-bar fadeOut'
        if (target) {
          // underBar.style.width = 0
          const target$ = of(target).pipe(
            delay(500),
            map(e => ({ left: e.offsetLeft, width: e.offsetWidth }))
          )
          target$.subscribe(e => {
            underBar.className = 'animated under-bar fadeInUp'
            underBar.style.left = e.left + e.width / 2.5 + 'px'
            // underBar.style.width = e.width + 'px'
          })
          return Promise.resolve(true)
        } else {
          return Promise.reject('No find target id')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-under-bar {
  height: 26px;
  position: relative;
  ul {
    position: absolute;
    margin: 0;
    padding: 0;
    list-style: none;
    z-index: 10;
    li {
      display: inline-block;
      margin: 0 10px 0 0;
      padding: 0 5px;
      cursor: pointer;
    }
  }

  .under-bar {
    display: block;
    width: 20px;
    position: absolute;
    left: 0;
    bottom: 5px;
    z-index: 0;
    height: 1px;
    background-color: #ab08b6;
  }
}
</style>
